/* eslint-disable */
import L from 'leaflet';
import './pdf-sheet-input.scss';

export class PdfSheetInput {
  constructor(options) {
    this.options = Object.assign(this.options, options);
    this.name = this.options.name;
    this._container = this.create(options);
  }

  getContainer() {
    return this._container;
  }

  deactivate() {
    this.options.selectArray.forEach((x) => {
      if (x.choice) {
        x.choice.classList.remove('active');
      }
    });
  }

  redraw(val) {
    const opt = this.options;
    const value = opt.setValue ? opt.setValue(val) : val;
    if (this.options.onRedraw) {
      this.options.onRedraw(value);
    }
    this.deactivate();
    const findSelect = opt.selectArray.find((x) => x.name === val || x.value === val);
    if (findSelect && findSelect.choice) {
      findSelect.choice.classList.add('active');
    }
  }

  create(opt) {
    const self = this;
    const withInput = opt.input !== undefined ? opt.input : true;
    const selector = L.DomUtil.create('div', 'pdf-sheet-plugin__selector');
    if (opt.label) {
      selector.appendChild(this._createLabel());
    }
    const widget = L.DomUtil.create('div', 'pdf-sheet-plugin__selector--widget', selector);

    const examples = L.DomUtil.create('div', '', widget);
    const className = ['pdf-sheet-plugin__selector--choice', opt.name].join(' ');

    opt.selectArray.forEach((x) => {
      const value = x.value || x.name;
      const isActive = self.options.value === x.name;
      const choice = L.DomUtil.create('div', className + (isActive ? ' active' : ''), examples);
      x.choice = choice;
      choice.innerHTML = opt.getHtml(x);
      L.DomEvent.on(choice, 'click', () => {
        self.deactivate();
        if (withInput) {
          self._setInput(value);
        }
        self.redraw(value);
      });
    });
    if (withInput) {
      widget.appendChild(this._createInput());
      if (opt.unit) {
        const unit = L.DomUtil.create('div', 'pdf-sheet-plugin__selector--unit', widget);
        unit.innerHTML = opt.unit;
      }
    }
    return selector;
  }

  _createLabel() {
    const label = L.DomUtil.create('div', 'pdf-sheet-plugin__selector--label');
    label.innerHTML = `${this.options.label}:`;
    return label;
  }

  _setInput(value) {
    this._input.value = value;
  }

  _createInput() {
    const opt = this.options;
    const input = L.DomUtil.create('input', 'pdf-sheet-plugin__selector--input');
    if (opt.updateInput) {
      opt.updateInput(input);
    }
    const currentValue = opt.selectArray.find((x) => {
      const value = x.name;
      return value === this.options.value;
    });
    if (currentValue) {
      input.value = currentValue.value || currentValue.name;
    }
    L.DomEvent.on(input, 'change', () => {
      let { value } = input;
      this.redraw(value);
      value = opt.setValue ? opt.setValue(value) : value;
    });
    this._input = input;
    return input;
  }
}
